import type { JSX } from 'react';
import { Button, Text } from '@ksyos/design-system';
import { ServiceActivityType } from '@common/enums';
import { formatString } from '@common/utils/formatString';
import { Modal } from '@frontend/components/elements/modals/Modal';
import { getSelectedLanguage } from '@frontend/translate';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { ProcessActivityReadContext } from './processActivityReadContext';

type ProcessActivityRemoveModalProps = Readonly<{
    onCancel: () => void;
    onConfirm: () => void;
}>;

export function ProcessActivityRemoveModal(props: ProcessActivityRemoveModalProps): JSX.Element {
    const { onCancel, onConfirm } = props;
    const { processActivity } = useDefinedContext(ProcessActivityReadContext);
    const { serviceActivityType } = processActivity.serviceActivity;

    return (
        <Modal
            actionButtons={[
                <Button
                    key={'no'}
                    onClick={onCancel}
                    variant="outline"
                >
                    {getSelectedLanguage().common.no}
                </Button>,
                <Button
                    key={'yes'}
                    onClick={onConfirm}
                >
                    {getSelectedLanguage().common.yes}
                </Button>,
            ]}
            isOpen={true}
            onClose={onCancel}
            size="small"
            title={getSelectedLanguage().common.removeForm}
        >
            <Text>{getModalText()}</Text>
        </Modal>
    );

    function getModalText(): string {
        if (serviceActivityType === ServiceActivityType.unknown) {
            return getSelectedLanguage().processActivity.cancel.removeDefault;
        }

        return formatString(getSelectedLanguage().processActivity.cancel.remove, [
            getSelectedLanguage().serviceActivityType[`${serviceActivityType}Pronoun`],
        ]);
    }
}
